module.exports = __webpack_public_path__ + "static/media/Scenario1_header.0548167a.jpg";